import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/antd.css";
import "./styles/index.scss";
import "./styles/leaflet.scss"
import { message } from "antd";
import { Buffer } from 'buffer';

window.Buffer = Buffer;

message.config({
  top: 100,
  duration: 2,
  maxCount: 3
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
